<template>
    <checkbox-all
        :name="name"
        :list="options"
        @select="(listUpdated: CheckboxAllOption<Record<string, unknown>>[]) => (options = listUpdated)"
        @unselect="(listUpdated: CheckboxAllOption<Record<string, unknown>>[]) => (options = listUpdated)"
    />
    <div>
        <base-checkbox
            v-for="(option, index) in options"
            :key="index"
            :id="index"
            :name="option.value + index"
            v-model:checked="option.checked"
            :label="option.text"
            :sub-label="option.subLabel"
            :disabled="option.disabled"
        />
    </div>
</template>

<script lang="ts" setup>
    import { CheckboxAllOption } from '@/interfaces/CheckboxAllOptions';

    defineProps<{ name: string }>();

    const options = defineModel<CheckboxAllOption<Record<string, unknown>>[]>('options', { required: true });
</script>
